import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Use matchMedia.matches instead of window.innerWidth to avoid forced reflow
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      // Use mql.matches instead of window.innerWidth - no reflow triggered
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", onChange);
    // Initial value from matchMedia - no forced reflow
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
